module.exports = __webpack_public_path__ + "static/media/mul.11e10aa6.png";